import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';

@Injectable()
export class FileSaverService {
    constructor() { }

    public downloadFile(data: Blob, fileName: string) {
        FileSaver.saveAs(data, fileName);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/file-saver.servive.ts